import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileDownload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileDownload"><Path d="M8.5 21.5H4.5V2.5H13L19.5 9V21.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 13.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 17.75L12 20.25L9.5 17.75" stroke="currentColor" strokeLinecap="square"/><Path d="M13 3V9H19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFileDownload;
